import { mediaIdFromValue } from "%/lib/media-reference";
import { useMediaPlaybackStore } from "%/stores/media-playback-store";

// Resolves option values that may hold a media_id (image/poster/background/
// fallback/video options picked through MediaPickerModal) to a playback URL,
// cached by media_id, so they render the same way legacy baked URLs do. Legacy
// URL strings pass through unchanged (so theme defaults / pre-migration values
// still render).
//
// Use resolveOptionMedia(rawValue) inside a computed. On a cache miss it
// schedules resolution on the next tick — never mutating reactive state during
// the render — and returns "" until the URL arrives; the cache update then
// re-renders the consuming computed.
export const OptionMediaResolverMixin = {
  data() {
    return {
      resolvedOptionMedia: {},
    };
  },
  methods: {
    isOptionMediaUnresolvable(rawValue) {
      const mediaId = mediaIdFromValue(rawValue);
      if (mediaId === null) {
        return false;
      }
      return useMediaPlaybackStore().isMediaUnresolvable(mediaId);
    },
    resolveOptionMedia(rawValue) {
      const mediaId = mediaIdFromValue(rawValue);
      if (mediaId === null) {
        return rawValue || "";
      }
      const resolved = this.resolvedOptionMedia[mediaId];
      if (resolved !== undefined) {
        return resolved;
      }
      const playbackStore = useMediaPlaybackStore();
      const seeded = playbackStore.playbackByMedia[mediaId];
      if (seeded) {
        return seeded.url;
      }
      if (playbackStore.isMediaUnresolvable(mediaId)) {
        return "";
      }
      this.$nextTick(() => this.fetchOptionMedia(mediaId));
      return "";
    },
    fetchOptionMedia(mediaId) {
      if (this.resolvedOptionMedia[mediaId] !== undefined) {
        return;
      }
      if (useMediaPlaybackStore().isMediaUnresolvable(mediaId)) {
        return;
      }
      this.resolvedOptionMedia = { ...this.resolvedOptionMedia, [mediaId]: "" };
      useMediaPlaybackStore().resolveMediaPlayback(mediaId, data => {
        this.resolvedOptionMedia = { ...this.resolvedOptionMedia, [mediaId]: data.url };
      });
    },
  },
};
